"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Xor = exports.Or = exports.And = exports.Not = exports.Filter = void 0;
class Filter {
    constructor(filterFn) {
        this.filterFn = filterFn;
    }
    static from(filterFn) {
        return new Filter(filterFn);
    }
}
exports.Filter = Filter;
function applyFilter(entity, node) {
    return node instanceof Filter ? node.filterFn(entity) : entity.has(node);
}
function Not(...nodes) {
    return Filter.from(entity => {
        for (const node of nodes) {
            if (applyFilter(entity, node)) {
                return false;
            }
        }
        return true;
    });
}
exports.Not = Not;
function And(...nodes) {
    return Filter.from(entity => {
        for (const node of nodes) {
            if (!applyFilter(entity, node)) {
                return false;
            }
        }
        return true;
    });
}
exports.And = And;
function Or(...nodes) {
    return Filter.from(entity => {
        for (const node of nodes) {
            if (applyFilter(entity, node)) {
                return true;
            }
        }
        return false;
    });
}
exports.Or = Or;
function Xor(...nodes) {
    return Filter.from(entity => {
        let match = false;
        for (const node of nodes) {
            if (applyFilter(entity, node)) {
                if (match) {
                    return false;
                }
                else {
                    match = true;
                }
            }
        }
        return match;
    });
}
exports.Xor = Xor;
